import { FormattedMessage } from "react-intl";
import { Button } from "@shltelemedicine/shl-ui-lib";
import EditButton from "../../../../../Shared/EditButton/EditButton";
import styles from "./StudyActions.module.css";
import linkUsersIcon from "../../../../../../assets/management/link_users.svg";
import unlinkUserIcon from "../../../../../../assets/management/unlink_user.svg";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
type StudyActionsProps = {
  hideDelete?: boolean;
  disableLinkUsers?: boolean;
  onLinkUsers?: () => void;
  onEditStudy?: () => void;
  onDeleteStudy?: () => void;
};

const StudyActions = ({
  hideDelete,
  disableLinkUsers,
  onLinkUsers,
  onEditStudy,
  onDeleteStudy,
}: StudyActionsProps) => {
  return (
    <div className="d-flex align-items-center">
      <Button
        variant=""
        className={styles.button}
        icon={{ src: linkUsersIcon, width: 18, height: 18 }}
        onClick={!disableLinkUsers ? onLinkUsers : undefined}
        disabled={disableLinkUsers}
      >
        <FormattedMessage
          id="MANAGEMENT.STUDIES.LINK_USERS"
          defaultMessage="Link Users"
        />
      </Button>
      <span className="mx-1"></span>
      <EditButton onClick={onEditStudy} />
      <span className="mx-1"></span>
      <Button
        className={styles.button}
        style={{ visibility: hideDelete ? "hidden" : "visible" }}
        onClick={onDeleteStudy}
      >
        <BaseIcon icon={unlinkUserIcon} className={styles.icon} />
      </Button>
    </div>
  );
};

export default StudyActions;
